import { useEffect, useState } from 'react';

const ColloredTd = ({ scrType, scr, colSpan = 1 }) => {
  const [bgColor, setBgColor] = useState('#ffffff');
  const [dpValue, setDpValue] = useState('');

  useEffect(() => {
    let returnColor = '#ffffff';

    // if (scr !== undefined && scr !== null && scr.length > 0) {
    //   if (scrType === 'OWAS') {
    //     if (Number(scr) >= 4) {
    //       returnColor = '#dc3545';
    //     } else if (Number(scr) >= 3) {
    //       returnColor = '#ff4200';
    //     } else if (Number(scr) >= 2) {
    //       returnColor = '#ffa600';
    //     } else {
    //       returnColor = '#28a745';
    //     }

    //     setDpValue('AC' + scr);
    //   } else if (scrType === 'RULA') {
    //     if (Number(scr) >= 7) {
    //       returnColor = '#dc3545';
    //     } else if (Number(scr) >= 5) {
    //       returnColor = '#ffa600';
    //     } else if (Number(scr) >= 3) {
    //       returnColor = '#fff700';
    //     } else {
    //       returnColor = '#28a745';
    //     }

    //     setDpValue(`${scr}`);
    //   } else if (scrType === 'REBA') {
    //     if (Number(scr) >= 11) {
    //       returnColor = '#dc3545';
    //     } else if (Number(scr) >= 8) {
    //       returnColor = '#ff4200';
    //     } else if (Number(scr) >= 4) {
    //       returnColor = '#ffa600';
    //     } else if (Number(scr) >= 2) {
    //       returnColor = '#fff700';
    //     } else {
    //       returnColor = '#28a745';
    //     }

    //     setDpValue(`${scr}`);
    //   }
    // }

    if (scr !== undefined && scr !== null && String(scr).length > 0) {
      if (scrType === 'OWAS') {
        if (Number(scr) >= 3) {
          returnColor = '#ffa600';
        } else if (Number(scr) >= 2) {
          returnColor = '#fff700';
        } else {
          returnColor = '#28a745';
        }

        setDpValue('AC' + scr);
      } else if (scrType === 'RULA') {
        if (Number(scr) >= 5) {
          returnColor = '#ffa600';
        } else if (Number(scr) >= 3) {
          returnColor = '#fff700';
        } else {
          returnColor = '#28a745';
        }

        setDpValue(`${scr}`);
      } else if (scrType === 'REBA') {
        if (Number(scr) >= 8) {
          returnColor = '#ffa600';
        } else if (Number(scr) >= 2) {
          returnColor = '#fff700';
        } else {
          returnColor = '#28a745';
        }

        setDpValue(`${scr}`);
      }
    }

    setBgColor(returnColor);
  }, [scrType, scr]);

  return (
    <td style={{ backgroundColor: bgColor }} colspan={colSpan}>
      {dpValue}
    </td>
  );
};

export default ColloredTd;
